import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('app_lang') || 'nl');

  const toggleLang = () => {
    const next = lang === 'en' ? 'nl' : 'en';
    setLang(next);
    localStorage.setItem('app_lang', next);
  };

  const setLanguage = (l) => {
    setLang(l);
    localStorage.setItem('app_lang', l);
  };

  return (
    <LanguageContext.Provider value={{ lang, language: lang, toggleLang, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
